/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/
// Core
import styled, { css } from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

// Types
import { Theme } from '../../../../../../types/theme';

// Components
import { StatusIndicatorProps } from '../../../../../../layout/elements/StatusIndicator';

const flexBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const borderColor = (
  { theme }: { theme: Theme },
) => theme.color.crusherDashboard.motorStatus.borderColor;

export const BorderBottomContainer = styled.div`
  border-bottom: 1px solid ${borderColor};
`;

export const MotorStatusContainer = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
`;

export const OverallStatusContainer = styled.div`
  width: 100%;
  padding: 0.75rem 1rem;
  ${flexBetween};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.1875rem 1.5rem;
  };
`;

export const VibrationContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-right: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.25rem;
  };
`;

export const Motor1AmpsContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.8125rem;
  };
`;

export const Motor2AmpsContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-bottom: 1px solid ${borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.8125rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    border-bottom: none;
    border-right: 1px solid ${borderColor};
  };
`;

export const DriveSpeedContainer = styled.div<{ $hasRightBorder?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.8125rem;
  };
  ${({ $hasRightBorder }) => $hasRightBorder && css`
    border-bottom: 1px solid ${borderColor};

    @media (min-width: ${BREAKPOINTS.xl}px) {
      border-bottom: none;
      border-right: 1px solid ${borderColor};
    };
  `}
`;

export const ShaftRpmContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.25rem;
  };
`;

export const PermissivesTitleContainer = styled.div`
  padding: 0.75rem 1rem 0.625rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.25rem 0.625rem 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.25rem 1.25rem 0.625rem 1.25rem;
  };
`;

export const PermissiveItem = styled.div<Pick<StatusIndicatorProps, 'status'>>`
  gap: 2px;
  padding: 0.5rem 1rem;
  width: 100%;
  background-color: ${({ status, theme }) => (status !== 'alarm'
    ? 'transparent'
    : theme.color.crusherDashboard.lubricationUnitDrawer.descriptionListErrorBackgroundColor
  )};
  border-radius: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0.625rem 1.25rem;
  };
`;

export const PermissivesContainer = styled.div<{ $seamless?: boolean }>`
  padding: 0 1rem 1rem 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1.25rem 1.25rem 1.25rem;
  };

  ${({ $seamless }) => $seamless && css`
    @media (max-width: ${BREAKPOINTS.xl - 1}px) {
      padding-bottom: 0;
    };
  `}
`;

export const CoastDownHistoryContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: ${({ theme }) => theme.color.crusherDashboard.motorStatus.footerBackgroundColor};
  border-radius: 0 0 4px 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1.25rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1.5rem;
  };
`;
